import { createAsyncThunk, createSlice, current } from '@reduxjs/toolkit'
import axios from 'axios'

const initialState = {
	entities: {},
	ids: [],
	isLoading: false,
	isInitialized: false,
}

function prepConfig(getState) {
	const {
		userLogin: { userInfo },
	} = getState()

	return {
		headers: {
			Authorization: `Bearer ${userInfo.token}`,
		},
	}
}

export const createPartnerApp = createAsyncThunk(
	'partnerApps/create',
	async (partnerApp, { getState, rejectWithValue }) => {
		try {
			const { data } = await axios.post(`/api/partnerApps`, partnerApp, prepConfig(getState))
			return data
		} catch (error) {
			return rejectWithValue('Failed to create partnerApp')
		}
	},
)

export const initializePartnerApps = createAsyncThunk(
	'partnerApps/initialize',
	async (payload, { getState, rejectWithValue }) => {
		try {
			return axios.get('/api/partnerApps', prepConfig(getState)).then(res => res.data)
		} catch (error) {
			return rejectWithValue('Failed to initialize partnerApps')
		}
	},
)

export const deletePartnerApp = createAsyncThunk(
	'partnerApps/delete',
	async (partnerAppId, { getState, rejectWithValue }) => {
		try {
			const { data } = await axios.delete(`/api/partnerApps/${partnerAppId}`, prepConfig(getState))
			return data
		} catch (error) {
			return rejectWithValue('Failed to delete partnerApp')
		}
	},
)

export const updatePartnerApp = createAsyncThunk(
	'partnerApps/update',
	async (partnerApp: any, { getState, rejectWithValue }) => {
		if (partnerApp && partnerApp._id) {
			try {
				const { data } = await axios.put(
					`/api/partnerApps/${partnerApp._id}`,
					partnerApp,
					prepConfig(getState),
				)
				return data
			} catch (error) {
				console.error(error)
				return rejectWithValue('Unable to update partnerApp')
			}
		}
		return rejectWithValue('Malformed partnerApp')
	},
)

// Extract the key out of the entitiy object
// eslint-disable-next-line no-unused-vars
const removeKey = (key, { [key]: _, ...rest }) => rest

const partnerAppSlice = createSlice({
	name: 'partnerApps',
	initialState,
	reducers: {},
	extraReducers: {
		[createPartnerApp.fulfilled as any]: (state, action) => {
			const partnerApp = action.payload
			state.entities[partnerApp._id] = partnerApp
		},
		[createPartnerApp.rejected as any]: (state, action) => {
			const partnerApp = action.payload
			state.entities[partnerApp._id] = partnerApp
		},
		[initializePartnerApps.fulfilled as any]: (state, action) => {
			const partnerApps = action.payload

			state.ids = partnerApps?.map((app, index) => {
				state.entities[app._id] = app
				return app._id
			})
			state.isLoading = false
			state.isInitialized = true
		},
		[initializePartnerApps.pending as any]: state => {
			state.isLoading = true
		},
		[initializePartnerApps.rejected as any]: (state, action) => {
			state.isLoading = false
			state.isInitialized = true
			state.error = action.error.message
		},
		[deletePartnerApp.fulfilled as any]: (state, action) => {
			const id = action.meta.arg
			state.entities = removeKey(id, state.entities)
			state.ids = state.ids.filter(stateId => stateId !== id)
		},
		[updatePartnerApp.fulfilled as any]: (state, action) => {
			const partnerApp = action.payload
			state.entities[partnerApp._id] = { ...action.payload, ...state.entities[partnerApp._id] }
		},
	} as any,
})

export default partnerAppSlice
